import { renderRoutes } from "@/shared/routes/generateRoutes.tsx";
import { useAppRoutes } from "@/shared/routes/use-app-routes.ts";
import { useAutoRefresh } from "@/shared/hooks/use-auto-refresh.ts";

const AppRoutes = () => {
  const routes = useAppRoutes();
  // Invalidating the data...
  //useAutoRefresh(() => {
    // Your API invalidation logic here
  //});

  const Routes = renderRoutes(routes);
  return <Routes />;
};

export default AppRoutes;
